import type { AgentApiJobSourcesShow } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

export default function useFetchJobSource(
  id: number | null | undefined,
  options?: {
    pollUntilCollectionComplete?: boolean;
    onCollectionComplete?: () => void;
    onLoginFailed?: () => void;
  }
) {
  const onCollectionComplete = useCallback(() => {
    options?.onCollectionComplete?.();
  }, [options?.onCollectionComplete]);

  const onLoginFailed = useCallback(() => {
    options?.onLoginFailed?.();
  }, [options?.onLoginFailed]);

  return useQuery({
    queryKey: [
      'JobSource',
      id,
      options?.pollUntilCollectionComplete,
      onCollectionComplete,
      onLoginFailed,
    ],
    queryFn: async () => {
      const response = await fetch(`/agent/api/job_sources/${id}.json`);
      const data: AgentApiJobSourcesShow = await response.json();

      if (
        options?.pollUntilCollectionComplete &&
        data.collection_status === 'success' &&
        onCollectionComplete
      ) {
        onCollectionComplete();
      }

      // ログイン失敗時のコールバック実行
      if (data.login_status === 'failed' && onLoginFailed) {
        onLoginFailed();
      }

      return data;
    },
    enabled: !!id,
    gcTime: 0,
    staleTime: 0,
    refetchInterval: (query) => {
      // ログイン失敗時はポーリングを停止
      if (query.state.data?.login_status === 'failed') {
        return false;
      }

      if (
        options?.pollUntilCollectionComplete &&
        query.state.data?.collection_status !== 'success'
      ) {
        return 2000;
      }
      return false;
    },
    refetchIntervalInBackground: true,
  });
}
